import { defineMessages } from "react-intl";

export const updateGrantRefundMessages = defineMessages({
  windowTitle: {
    defaultMessage: "Edit grant refund",
    id: "+sXiWx",
    description: "window title",
  },
  formSubmitted: {
    defaultMessage: "Refund grant for order #{orderNumber} was updated",
    id: "gaOXvo",
    description: "notification, form submitted",
  },
});
